import { Skeleton, Spacer } from '@/components/ui';
import { DynamicGridContainer } from '@/components/layout/Containers';

export default function Loading() {
  return (
    <div className="h-full bg-primary flex flex-col overflow-hidden">
      {/* Header skeleton */}
      <div className="sticky top-0 z-20 border-b border-tertiary bg-primary" id="unit-header">
        <div className="flex items-center justify-between gap-2 max-w-[1280px] px-6 md:px-12 py-6 w-full mx-auto">
          <div className="flex items-center gap-2 min-w-0">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-4" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-4 hidden sm:block" />
            <Skeleton className="h-4 w-40 hidden sm:block" />
          </div>
          <div className="hidden md:flex gap-2 items-center justify-end shrink-0">
            <Skeleton className="h-10 w-10 rounded-full" />
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
        </div>
      </div>

      {/* Page content skeleton */}
      <div className="page-container md:!py-8 !py-0">
        {/* Image carousel placeholder - full width skeleton */}
        <DynamicGridContainer className="md:!pl-12 !px-0 relative">
          <Skeleton className="w-full h-[465px] rounded-2xl" />
        </DynamicGridContainer>

        <DynamicGridContainer>
          <div className="content-grid lg:!gap-x-8 mt-6 md:mt-8">
            <div className="col-span-full md:col-span-5 lg:col-span-7 space-y-6 md:space-y-8">
              {/* Unit details */}
              <div className="flex flex-col gap-3 w-full px-2 md:px-4">
                <Skeleton className="h-7 w-48" />
                <div className="flex flex-wrap gap-3">
                  <Skeleton className="h-5 w-24" />
                  <Skeleton className="h-5 w-28" />
                  <Skeleton className="h-5 w-20" />
                </div>
              </div>

              {/* Highlights */}
              <div className="flex flex-col gap-3 w-full px-2 md:px-4">
                <Skeleton className="h-6 w-40" />
                {[0, 1].map(i => (
                  <div key={i} className="flex items-center gap-4 py-3">
                    <Skeleton className="h-6 w-6 rounded" />
                    <div className="flex-1">
                      <Skeleton className="h-4 w-56 mb-2" />
                      <Skeleton className="h-4 w-full" />
                    </div>
                    <Skeleton className="h-4 w-4" />
                  </div>
                ))}
              </div>

              {/* Description */}
              <div className="flex flex-col gap-3 w-full px-2 md:px-4">
                <Skeleton className="h-6 w-32" />
                <div className="flex flex-col gap-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                </div>
              </div>

              {/* Map */}
              <div className="flex flex-col gap-3 w-full px-2 md:px-4">
                <Skeleton className="h-6 w-28" />
                <Skeleton className="h-64 w-full rounded-2xl" />
              </div>
            </div>

            <div className="hidden md:block md:col-span-3 lg:col-start-9 lg:col-span-4 space-y-6 w-full pr-4">
              <div className="sticky top-8 self-start space-y-4 w-full">
                <div className="bg-primary rounded-2xl border border-secondary p-4 w-full">
                  <Skeleton className="h-8 w-40 mb-2" />
                  <Skeleton className="h-5 w-24 mb-4" />
                  <div className="flex flex-col gap-2">
                    <Skeleton className="h-12 w-full rounded-full" />
                    <Skeleton className="h-12 w-full rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DynamicGridContainer>
      </div>
    </div>
  );
}
